import { useState } from 'react';
import useSWRInfinite from 'swr/infinite';
import { jsonFetcherWithHandler as fetcher } from 'lib/swr';
import { gridItemHandler } from '../gridV2/CommunityView';

import { CommunityGridItem, CommunityUserProfile } from 'types/community';
import CommunityGrid from '../gridV2/CommunityGrid';
import { getCommunityPostReactedUrl } from 'lib/community';
import EmptyPlaceholder from '../profile/EmptyPlaceholder';

type Props = {
  profile: CommunityUserProfile;
};

export default function UserLikesGrid({ profile }: Props) {
  const [hasMoreItems, setHasMoreItems] = useState<boolean>(true);
  const userId = profile.ownerId;

  function getPostsUrl(
    pageIndex: Number,
    previousPageData: CommunityGridItem[] | null
  ) {
    if (pageIndex === 0) {
      return getCommunityPostReactedUrl(userId);
    }

    if (previousPageData === null || previousPageData.length === 0) {
      setHasMoreItems(false);
      return null;
    }

    return getCommunityPostReactedUrl(userId, pageIndex);
  }

  const {
    data: gridItems,
    setSize,
    isValidating,
  } = useSWRInfinite<CommunityGridItem>(getPostsUrl, fetcher(gridItemHandler));

  function onScrollNearEnd() {
    setSize((size) => size + 1);
  }

  const flattenedGridItems = gridItems ? gridItems.flat() : null;
  return (
    <div>
      {flattenedGridItems && flattenedGridItems.length === 0 ? (
        <EmptyPlaceholder
          text={`It looks like ${profile.username} liked any posts yet.`}
        />
      ) : (
        <CommunityGrid
          gridItems={gridItems ? gridItems.flat() : gridItems}
          hasMoreItems={hasMoreItems}
          isValidating={isValidating}
          onScrollNearEnd={onScrollNearEnd}
        />
      )}
    </div>
  );
}
